export var getCurrentUrl = function getCurrentUrl() {
  return new URL(window.location.href);
};
//# sourceMappingURL=getCurrentUrl.js.map